export interface Tematica {
    idTematica: number,
    estado: string,
    txtNombre: string,
    txtDescripcion: string
}

export function GetVoidTematica(): Tematica {
    return {
        idTematica: 0,
        estado: 'A',
        txtNombre: '',
        txtDescripcion: ''
    }
}